// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------table------------------------------- */
.admin-table.table thead th {
    padding: 15px 0;
    height: 50px;
}

.admin-table.table tbody tr {
    height: 50px;
}

.admin-table .btn {
    color: var(--white);
    border-radius: 5px;
    text-transform: capitalize;
    font-size: 12px;
    padding: 1px 10px;
}

.admin-table .btn.editButton {
    background-color: var(--theme1);
}

.admin-table .btn.editButton:hover {
    background-color: var(--theme1);
    color: var(--white);
}

.admin-table .btn.deleteButton {
    background-color: var(--theme2);
}

.admin-table .btn.deleteButton:hover {
    background-color: var(--theme2);
    color: var(--white);
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/adminTable.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB","sourcesContent":["/* -----------------------table------------------------------- */\n.admin-table.table thead th {\n    padding: 15px 0;\n    height: 50px;\n}\n\n.admin-table.table tbody tr {\n    height: 50px;\n}\n\n.admin-table .btn {\n    color: var(--white);\n    border-radius: 5px;\n    text-transform: capitalize;\n    font-size: 12px;\n    padding: 1px 10px;\n}\n\n.admin-table .btn.editButton {\n    background-color: var(--theme1);\n}\n\n.admin-table .btn.editButton:hover {\n    background-color: var(--theme1);\n    color: var(--white);\n}\n\n.admin-table .btn.deleteButton {\n    background-color: var(--theme2);\n}\n\n.admin-table .btn.deleteButton:hover {\n    background-color: var(--theme2);\n    color: var(--white);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
